import React, { useState, useEffect, useRef } from "react";
import { Text, StyleSheet, View, Dimensions } from "react-native";
import { Feather } from "@expo/vector-icons";
import {
  CodeField,
  Cursor,
  useClearByFocusCell,
} from "react-native-confirmation-code-field";

export default function AuthCodeInput({
  label,
  onValueChange,
  cellCount,
  isPassword = false,
  error,
}) {
  useEffect(() => {
    input.current.focus()
    // input.current.useBlurOnFulfill({ value, cellCount });
  })
  const input = useRef()
  const [value, setValue] = useState("");
  const [enableMask, setEnableMask] = useState(true);
  const toggleMask = () => setEnableMask((f) => !f);
  const [props, getCellOnLayoutHandler] = useClearByFocusCell({
    value,
    setValue,
  });

  const renderCell = ({ index, symbol, isFocused }) => {
    let textChild = null;

    if (symbol) {
      textChild = isPassword && enableMask ? "•" : symbol;
    } else if (isFocused) {
      textChild = <Cursor />;
    }

    return (
      <Text
        key={index}
        style={[styles.cell, isFocused && styles.focusCell]}
        onLayout={getCellOnLayoutHandler(index)}
      >
        {textChild}
      </Text>
    );
  };

  return (
    <>
      <Text style={styles.label}>{label}</Text>
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <CodeField
          {...props}
          ref={input}
          value={value}
          autoFocus
          onChangeText={(val) => {
            setValue(val);
            onValueChange(val);
          }}
          cellCount={cellCount}
          rootStyle={styles.codeFieldRoot}
          keyboardType="number-pad"
          textContentType="oneTimeCode"
          renderCell={renderCell}
        />
        {isPassword &&
          <Text style={styles.toggle} onPress={toggleMask}>
            {enableMask ? <Feather name="eye-off" size={18} color="#222" />
              : <Feather name="eye" size={18} color="#222" />}
          </Text>
        }
      </View>
      {error ? <Text style={styles.error}>{error}</Text> : null}
    </>
  );
}

const window_width = Dimensions.get('screen').width;

const styles = StyleSheet.create({
  label: {
    fontSize: 12,
    marginBottom: 20,
  },
  input: {
    width: "100%",
    borderBottomWidth: 0.5,
  },
  error: {
    marginTop: 15,
    color: "red",
  },
  codeFieldRoot: {
    flex: 1,
    justifyContent: "flex-start"
  },
  cell: {
    width: Math.min(40, Math.ceil(window_width*0.1)),
    height: Math.min(50, Math.ceil(window_width*0.12)),
    marginRight: 10,
    borderRadius: 8,
    fontSize: (window_width < 360 ? 20 : 24),
    lineHeight: Math.min(50, Math.ceil(window_width*0.12)),
    borderWidth: 2,
    borderColor: "#00000030",
    textAlign: "center",
  },
  focusCell: {
    borderColor: "#1FBFB5",
  },
  toggle: {
    padding: 15,
  }
});
